<template>
  <v-app>
    <v-container fluid class="error-page">
      <v-row class="logo-wrapper">
        <span class="logo-title"> DIGIPATS </span>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="8">
          <div class="card">
            <span class="error-logo">404</span>
            <p class="error-text">
              UPS. PARECE QUE LA PÁGINA QUE ESTÁS BUSCANDO YA NO EXISTE
            </p>
            <p class="error-subtext">
              PERO ESTAMOS AQUÍ PARA TRAERTE DE VUELTA A LA SEGURIDAD
            </p>

            <v-btn
              class="text-capitalize"
              dark
              x-large
              :color="config.light.primary"
              to="login"
            >
              Inicio
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import config from "../../config";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Error",
  data() {
    return {
      config,
    };
  },
};
</script>

<style src="./Error.scss" lang="scss"></style>
